import { db } from '../firebase';
import { collection, addDoc, serverTimestamp, Firestore } from 'firebase/firestore';

export async function subscribeToNewsletter(email: string): Promise<{ success: boolean; message: string }> {
    try {
        if (!email) {
            return { success: false, message: 'Email is required' };
        }

        // Check if Firebase is initialized
        if (!db) {
            console.error('❌ Firebase not initialized');
            return { success: false, message: 'Firebase not initialized. Please check your environment variables.' };
        }

        const firestoreDb: Firestore = db;
        await addDoc(collection(firestoreDb, 'newsletter'), {
            email,
            createdAt: serverTimestamp()
        });

        return { success: true, message: 'Subscribed successfully' };
    } catch (error) {
        console.error('Newsletter subscription error:', error);
        const errorMessage = error instanceof Error ? error.message : 'Unknown error';
        
        if (import.meta.env.DEV) {
            console.error('Error details:', errorMessage);
        }
        
        return { success: false, message: 'Internal Server Error' };
    }
}

